(function () {
  'use strict';
  if (window.voroPillNav) return;
  window.voroPillNav = { version: 1 };

  var RECENT_KEY = 'voroRecentSearches';
  var RECENT_MAX = 5;
  var SVG = '<svg class="voro-pn-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var ICON = {
    clock: SVG + '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>',
    search: SVG + '<circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5"/></svg>',
    arrow: SVG + '<path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    page: SVG + '<path d="M6.5 3.5h7l4 4v13h-11z"/><path d="M13.5 3.5v4h4M9 12h6M9 15.5h6"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var whole = Math.round(n * 100) % 100 === 0;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency', currency: cur,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function sized(src, w) {
    if (!src || src.indexOf('cdn.shopify.com') === -1 && src.indexOf('/cdn/shop/') === -1) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function sheet() { return document.querySelector('[data-voro-ss]'); }
  function field(d) { return d.querySelector('input[name="q"]'); }
  function currentQ(d) { return field(d).value.trim(); }

  function readRecent() {
    try {
      var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (s) { return typeof s === 'string' && s.trim(); }).slice(0, RECENT_MAX) : [];
    } catch (e) {
      return [];
    }
  }

  function saveRecent(q) {
    q = (q || '').trim();
    if (!q) return;
    try {
      var list = readRecent().filter(function (s) { return s.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    } catch (e) {   }
  }

  function searchUrl(d, q) {
    var form = d.querySelector('form');
    return (form.getAttribute('action') || '/search') + '?q=' + encodeURIComponent(q);
  }

  function row(href, thumbHtml, title, metaHtml) {
    return '<li><a class="voro-ss__row" href="' + esc(href) + '">' + thumbHtml +
      '<span class="voro-ss__txt"><span class="voro-ss__title">' + esc(title) + '</span>' +
      (metaHtml ? '<span class="voro-ss__meta">' + metaHtml + '</span>' : '') +
      '</span></a></li>';
  }

  function thumb(src) {
    if (!src) return '<span class="voro-ss__thumb voro-ss__thumb--icon" aria-hidden="true">' + ICON.search + '</span>';
    return '<span class="voro-ss__thumb" aria-hidden="true"><img src="' + esc(sized(src, 120)) +
      '" alt="" width="52" height="52" loading="lazy" decoding="async"></span>';
  }

  function renderRecent(d) {
    var box = d.querySelector('[data-voro-ss-recent]');
    if (!box) return;
    var list = readRecent();
    box.querySelector('ul').innerHTML = list.map(function (q) {
      return row(searchUrl(d, q), '<span class="voro-ss__thumb voro-ss__thumb--icon" aria-hidden="true">' + ICON.clock + '</span>', q, '');
    }).join('');
    box.hidden = !list.length;
  }

  function setStatus(d, text) {
    var s = d.querySelector('[data-voro-ss-status]');
    if (s) s.textContent = text;
  }

  function showIdle(d) {
    d.querySelector('[data-voro-ss-idle]').hidden = false;
    var out = d.querySelector('[data-voro-ss-results]');
    out.hidden = true;
    out.innerHTML = '';
    setStatus(d, '');
  }

  function priceMeta(p) {
    var min = parseFloat(p.price_min != null ? p.price_min : p.price);
    var max = parseFloat(p.price_max != null ? p.price_max : p.price);
    var html = '<span class="voro-ss__price">' + (max > min ? 'From ' : '') + esc(money(min)) + '</span>';
    var cmp = parseFloat(p.compare_at_price_max);
    if (max === min && isFinite(cmp) && cmp > min) html += '<s class="voro-ss__cmp">' + esc(money(cmp)) + '</s>';
    if (p.available === false) html += ' · <span class="voro-ss__so">Sold out</span>';
    return html;
  }

  function heading(text) {
    return '<p class="voro-ss__h" role="heading" aria-level="2">' + esc(text) + '</p>';
  }

  function allLink(d, q, lead) {
    return '<a class="voro-ss__all" href="' + esc(searchUrl(d, q)) + '">' + esc(lead) + ' “' + esc(q) + '”' + ICON.arrow + '</a>';
  }

  function count(n, noun) {
    return n + ' ' + noun + (n === 1 ? '' : 's');
  }

  function paint(d, q, res) {
    var idle = d.querySelector('[data-voro-ss-idle]');
    var out = d.querySelector('[data-voro-ss-results]');
    var cols = (res.collections || []).slice(0, 3);
    var prods = (res.products || []).slice(0, 6);
    var pages = (res.pages || []).slice(0, 3);
    var h = '';

    if (!cols.length && !prods.length && !pages.length) {
      h = '<p class="voro-ss__empty">No quick matches for “' + esc(q) + '”. Try a model or a brand name.</p>' +
        allLink(d, q, 'Search everything for');
      idle.hidden = false;
      setStatus(d, 'No quick matches. Press search to see all results.');
    } else {
      idle.hidden = true;
      if (cols.length) {
        h += heading('Collections') + '<ul class="voro-ss__list" role="list">' + cols.map(function (c) {
          return row(c.url, thumb(c.featured_image && c.featured_image.url), c.title, 'Collection');
        }).join('') + '</ul>';
      }
      if (prods.length) {
        h += heading('Products') + '<ul class="voro-ss__list" role="list">' + prods.map(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url);
          return row(p.url, thumb(img), p.title, priceMeta(p));
        }).join('') + '</ul>';
      }
      if (pages.length) {
        h += heading('Pages') + '<ul class="voro-ss__list" role="list">' + pages.map(function (pg) {
          return row(pg.url, '<span class="voro-ss__thumb voro-ss__thumb--icon" aria-hidden="true">' + ICON.page + '</span>', pg.title, 'Page');
        }).join('') + '</ul>';
      }
      h += allLink(d, q, 'See all results for');
      setStatus(d, count(prods.length, 'product') + ', ' + count(cols.length, 'collection') + ' and ' +
        count(pages.length, 'page') + ' found');
    }
    out.innerHTML = h;
    out.hidden = false;
  }

  var timer = null;
  var ctrl = null;
  var cache = {};

  function update(d, raw) {
    var q = (raw || '').trim();
    if (!q) {
      if (ctrl) ctrl.abort();
      showIdle(d);
      return;
    }
    if (cache[q]) { paint(d, q, cache[q]); return; }
    if (ctrl) ctrl.abort();
    ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var base = d.getAttribute('data-suggest-url') || '/search/suggest.json';
    var url = base + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last';
    fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('suggest ' + r.status); return r.json(); })
      .then(function (data) {
        var res = (data && data.resources && data.resources.results) || {};
        cache[q] = res;
        if (currentQ(d) === q) paint(d, q, res);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (currentQ(d) !== q) return;
        var out = d.querySelector('[data-voro-ss-results]');
        out.innerHTML = allLink(d, q, 'Search for');
        out.hidden = false;
        setStatus(d, 'Suggestions are unavailable. Press search to see all results.');
      });
  }

  function schedule(d, value) {
    var clear = d.querySelector('[data-voro-ss-clear]');
    if (clear) clear.hidden = !value;
    clearTimeout(timer);
    timer = setTimeout(function () { update(d, value); }, 160);
  }

  function openSheet() {
    var d = sheet();
    if (!d || typeof d.showModal !== 'function') return false;
    if (!d.open) {
      try { d.showModal(); } catch (e) { return false; }
    }
    renderRecent(d);
    var input = field(d);
    input.focus();
    if (input.value) input.select();
    return true;
  }

  function closeSheet(d) {
    if (d && d.open) d.close();
  }

  function tabbar() { return document.querySelector('[data-voro-tabbar]'); }

  var lastY = null;
  var ticking = false;
  function pinHeader(y) {
    var h = document.querySelector('.page__header--mobile.voro-ph[data-voro-pin]');
    if (!h || !h.getClientRects().length) return;
    var on = y > 120;
    if (on === h.classList.contains('page__header--sticky')) return;
    if (on) {
      if (h.clientHeight) h.parentElement.style.height = h.clientHeight + 'px';
      h.classList.add('page__header--sticky');
    } else {
      h.parentElement.style.height = null;
      h.classList.remove('page__header--sticky');
    }
  }

  function pageY() {
    return window.pageYOffset || (document.scrollingElement || document.documentElement).scrollTop || 0;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = pageY();
      pinHeader(y);
      var b = tabbar();
      if (!b) return;
      if (lastY === null) { lastY = y; return; }
      var dy = y - lastY;
      if (y < 80) {
        b.classList.remove('is-hidden');
        lastY = y;
      } else if (dy > 8) {
        b.classList.add('is-hidden');
        lastY = y;
      } else if (dy < -8) {
        b.classList.remove('is-hidden');
        lastY = y;
      }
    });
  }

  function syncBadge(el) {
    var n = parseInt(el.textContent, 10) || 0;
    if (n > 0) el.removeAttribute('data-empty');
    else el.setAttribute('data-empty', '');
    var host = el.closest('a');
    var sr = host && host.querySelector('[data-voro-tab-count]');
    if (sr) sr.textContent = n > 0 ? ', ' + count(n, 'item') : '';
  }

  function watchBadges() {
    if (typeof MutationObserver !== 'function') return;
    document.querySelectorAll('[data-voro-tab-badge]').forEach(function (el) {
      if (el.__voroObs) return;
      syncBadge(el);
      el.__voroObs = new MutationObserver(function () { syncBadge(el); });
      el.__voroObs.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function revealActivePill() {
    document.querySelectorAll('.voro-ph__list').forEach(function (ul) {
      var a = ul.querySelector('.is-active');
      if (!a || ul.clientWidth < 240 || ul.scrollWidth <= ul.clientWidth) return;
      var box = ul.getBoundingClientRect();
      var pill = a.parentElement.getBoundingClientRect();
      if (pill.left >= box.left && pill.right <= box.right) return;
      var left = pill.left - box.left + ul.scrollLeft;
      ul.scrollLeft = Math.max(0, left - (ul.clientWidth - pill.width) / 2);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var modified = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0;

    var opener = t.closest('[data-voro-ss-open]');
    if (opener) {
      if (!modified && openSheet()) e.preventDefault();
      return;
    }

    var tab = t.closest('[data-voro-tab]');
    if (tab && !modified) {
      var act = tab.getAttribute('data-voro-tab');
      if (act === 'menu') {
        var cb = document.getElementById('open-mobile-nav');
        if (cb) {
          e.preventDefault();
          cb.checked = !cb.checked;
          cb.dispatchEvent(new Event('change', { bubbles: true }));
          var first = cb.checked && document.querySelector('.mobile__navigation a[href]');
          if (first) first.focus({ preventScroll: true });
        }
      } else if (act === 'chat') {
        if (typeof window.Chatra === 'function' && document.getElementById('chatra')) {
          e.preventDefault();
          window.Chatra('openChat', true);
        }
      } else if (act === 'search') {
        if (openSheet()) e.preventDefault();
      }
      return;
    }

    var d = t.closest('[data-voro-ss]');
    if (!d) return;
    if (t.closest('[data-voro-ss-close]')) {
      closeSheet(d);
      return;
    }
    if (t.closest('[data-voro-ss-clear]')) {
      var input = field(d);
      input.value = '';
      schedule(d, '');
      input.focus();
      return;
    }
    if (t.closest('.voro-ss__results a[href]') && currentQ(d)) saveRecent(currentQ(d));
  });

  document.addEventListener('input', function (e) {
    var i = e.target;
    if (!i || !i.closest || i.name !== 'q') return;
    var d = i.closest('[data-voro-ss]');
    if (d) schedule(d, i.value);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.closest) return;
    var d = f.closest('[data-voro-ss]');
    if (!d) return;
    var q = currentQ(d);
    if (!q) { e.preventDefault(); return; }
    saveRecent(q);
  });

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || cb.id !== 'open-mobile-nav') return;
    var openers = [].slice.call(document.querySelectorAll('[data-voro-tab="menu"], [data-voro-menu]'));
    openers.forEach(function (t) { t.setAttribute('aria-expanded', cb.checked ? 'true' : 'false'); });
    var nav = document.querySelector('.mobile__navigation');
    if (cb.checked || !nav || !nav.contains(document.activeElement)) return;
    var back = openers.filter(function (t) { return t.offsetParent !== null; })[0];
    if (back) back.focus({ preventScroll: true });
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-voro-menu]')) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var cb = document.getElementById('open-mobile-nav');
    if (!cb) return;
    e.preventDefault();
    cb.checked = !cb.checked;
    cb.dispatchEvent(new Event('change', { bubbles: true }));
    var first = cb.checked && document.querySelector('.mobile__navigation a[href]');
    if (first) first.focus({ preventScroll: true });
  });

  document.addEventListener('touchmove', function (e) {
    var a = document.activeElement;
    if (a && a.name === 'q' && e.target && e.target.closest && e.target.closest('.voro-ss__body')) a.blur();
  }, { passive: true });

  window.addEventListener('scroll', onScroll, { passive: true });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) closeSheet(sheet());
  });

  function init() {
    watchBadges();
    revealActivePill();
    pinHeader(pageY());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
